import React from 'react';
import AppointmentContent from './AppointmentContent';
import {
  Dialog,
  IconButton,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(149, 152, 154, 0.43)',
      borderRadius: 5,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(149, 152, 154, 1)',
    },
  },
});

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const AppointmentDialog = ({
  onClose,
  isOpen,
  exhibitor,
  loggedUser,
  onSubmit,
}) => {
  if (!isOpen) return null;
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl).Book;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledDialog
      onClose={onClose}
      open={isOpen}
      maxWidth={'lg'}
      id="appointment-menu"
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div
        tabIndex={0}
        role="button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: isSmDown ? 25 : 20,
          right: isSmDown ? 25 : 30,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={'small'} />
        </StyledIconButton>
      </div>
      <div style={{ padding: '40px' }}>
        <Typography variant="m-bold" sx={{ mb: '25px' }}>
          {i18n.title} {exhibitor?.name}
        </Typography>
        <AppointmentContent
          user={loggedUser}
          brandId={exhibitor?.salesforceId}
          onSubmit={onSubmit}
          hasVisits={exhibitor.appuntamenti}
        />
      </div>
    </StyledDialog>
  );
};

export { AppointmentDialog };
